import { camelizeKeys } from 'humps'
import { stringify } from 'qs'
import featureToggles from 'shared/featureToggles'

const STRINGIFY_OPTIONS = {
    allowDots: true,
}

export function jsonPut(...args) {
    return put(...args)
        .then(parseResponse)
        .then(checkFortResponseErrors)
        .catch(err => {
            throw err
        })
}

export function jsonPost(...args) {
    return post(...args)
        .then(parseResponse)
        .then(checkFortResponseErrors)
        .catch(err => {
            throw err
        })
}

export function jsonGet(...args) {
    return get(...args).then(toJson)
}

export function postFormData(...args) {
    return postForm(...args)
        .then(parseResponse)
        .then(checkFortResponseErrors)
        .catch(err => {
            throw err
        })
}

export function deleteJson(...args) {
    return deleteMethod(...args)
        .then(parseResponse)
        .then(checkFortResponseErrors)
        .catch(err => {
            throw err
        })
}

export const handleSerializedResponse = json => {
    const { d: data } = json

    if (typeof data !== 'undefined')
        try {
            return JSON.parse(data)
        } catch (exception) {
            return data
        }
    else return json
}

export function deleteMethod(url, params, headers = {}) {
    return fetch(`${url}${params ? `?${stringify(params, STRINGIFY_OPTIONS)}` : ''}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            ...headers,
        },
        mode: 'cors',
        credentials: 'include',
    }).catch(() => {
        throw new Error('error.network')
    })
}

export function put(url, params, json, headers) {
    return fetch(`${url}${params ? `?${stringify(params, STRINGIFY_OPTIONS)}` : ''}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            ...headers,
        },
        mode: 'cors',
        credentials: 'include',
        body: JSON.stringify(json),
    }).catch(() => {
        throw new Error('error.network')
    })
}

export function postForm(url, data, headers) {
    const urlencoded = new URLSearchParams()
    for (const property in data) {
        urlencoded.append(property, data[property])
    }

    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            ...headers,
        },
        mode: 'cors',
        credentials: 'include',
        body: urlencoded,
    }).catch(() => {
        throw new Error('error.network')
    })
}

export function post(url, json, headers) {
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...headers,
        },
        mode: 'cors',
        credentials: 'include',
        body: JSON.stringify(json),
    }).catch(() => {
        throw new Error('error.network')
    })
}

export function get(url, params, headers = {}) {
    return fetch(`${url}${params ? `?${stringify(params, STRINGIFY_OPTIONS)}` : ''}`, {
        method: 'GET',
        headers,
        mode: 'cors',
        credentials: 'include',
    }).catch(() => {
        throw new Error('error.network')
    })
}

export function camelize(data) {
    return data instanceof Object
        ? camelizeKeys(data, (key, convert) => (/^[A-Z0-9_]+$/.test(key) ? key.toLowerCase() : convert(key)))
        : data
}

export function toJson(response) {
    return response.json()
}

export function parseResponse(response) {
    return response.json().then(json => {
        const deserialised = handleSerializedResponse(json)
        const camelized = camelize(deserialised)

        return { status: response.status, data: camelized }
    })
}

export function checkFortResponseErrors(response) {
    if (!response) return
    const { data } = response
    // I added here a new condition , but left a previous one also(maybe in some case this error is also occurred)
    if (data.anErrorOccurred || (data.error && response.status === 401)) {
        throw new Error(data.errorDescription)
    }

    if (data.stackTrace) {
        const stackTrace = JSON.parse(data.stackTrace)
        throw new Error(stackTrace.Message)
    }

    if (featureToggles.newAuthFlow) {
        checkNAmApiErrors(response)
    }

    return data
}

export function checkNAmApiErrors(response) {
    const { data = {}, status } = response

    if (status === 500) {
        const message = data.message || 'Something went wrong'
        throw Error(message)
    }

    return response
}

export const commonThinxHeaders = (token, withApiKey, requestHeaders) => {
    let headers = { 'X-Tenant': THINX_X_TENANT }

    if (token) {
        headers['Authorization'] = `Bearer ${token}`
    }

    if (withApiKey) {
        headers['X-API-Key'] = THINX_BASE_API_URL_API_KEY
    }

    if (requestHeaders) {
        headers = { ...headers, ...requestHeaders }
    }

    return headers
}
